import React from 'react'

const context = React.createContext()
export const coinValuesContext = React.createContext()

export default context